import { Injectable } from '@angular/core';


// fetch our configuration of core entities
import { UiStateMachineConfig } from './../global';





export class UiStateEngineFeature {

    private schema: any = [ 'id', 'title', 'showCount', 'allowed', 'menu', 'icon', 'router', 'onclick', 'tooltip', 'showOptionIn', 'showContentIn' ];


    public id: string = null;
    public title: string = null;
    public showCount: number = null;

    public allowed:boolean = false;

    public icon: any = null;
    public router: any = null;
    public onclick: any = null;

    public menu:any = null;

    public tooltip: any = null;
    public showOptionIn: any = null;
    public showContentIn: any = null;


    constructor ( id:string, obj:object ) {

        this.id = id;

        this.schema.forEach( item => {
            if ( obj[item] ) {
                this[item] = obj[item];
            }
        });
    }

}
@Injectable({
    // preferred way of providing a singleton service class
    providedIn: 'root'
})
// simple class for running the show2
export class UiStateEngine {

    // list our widgets
    private widgets: Map<string,any> = new Map();

    // list our features
    private features: Map<string,any> = new Map();

    // list of where the features are to be shown
    private show: Map<string,any> = new Map();

    // current mode
    private currentMode: string = null;

    // model state
    modelDirty: boolean = true;

    // cache of data
    cache: Map<string,any> = new Map();

    constructor() {
        // console.log ( 'state engine started' );
        this.addWidgets ( UiStateMachineConfig.widgets );
    }

    reset() {
        // clear the cache and the features (widgets stay put)
        this.cache.clear();
        this.features.clear();
    }

    addWidgets ( inp: object[] ) {
        inp.forEach(element => {
            this.addWidget ( element['id'], inp );
        },true);
    }

    addWidget ( widget_id: string, inp:object ) {
        this.widgets.set ( widget_id, inp );
    }

    
    // get a list of features of a widget
    getWidget ( widget_id: string ) {

        let result = null;

        // if it's been asked for before, return a cached version
        if ( result = this.cache.get ( widget_id ) ) {
            // console.log ( 'state returning ['+widget_id+'] (cached)', result);
            return result;
        }

        // no cache? Let's create a new one
        let ret = [];

        // go through all features
        for ( const [f_id, f] of this.features.entries() ) {
            // show in our widget?
            if ( f.showOptionIn && f.showOptionIn == widget_id ) {
                ret.push ( f );
            }
        }

        // save to the cache for future uses
        this.cache.set ( widget_id, ret );

        return ret;
    }

    addFeature ( feature_id:string, inp:any ) {

        // console.log ( 'add: '+feature_id, typeof inp['allowed'], inp['allowed'], inp.hasOwnProperty('allowed') );

        // if no allow input, then default is to allow
        if ( ! inp.hasOwnProperty('allowed') ) {
            inp['allowed'] = true;
        }

        // is it allowed?
        if ( inp['allowed'] ) {

            // add it
            this.features.set ( feature_id, new UiStateEngineFeature ( feature_id, inp ) );

        }
    }

    getCurrentMode() {
        return this.currentMode;
    }
}
